// src/components/Product/ProductCard/ProductSelectionDialog.js
import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  Box,
  IconButton,
  Divider,
  CircularProgress,
  Alert
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import ShoppingBagIcon from '@mui/icons-material/ShoppingBag';
import ColorSelector from './ColorSelector';
import SizeSelector from './SizeSelector';

const ProductSelectionDialog = ({
  open,
  onClose,
  loading,
  error,
  product,
  productColors,
  selectedColorIndex,
  onColorChange,
  availableSizes,
  selectedSize,
  onSizeChange,
  onAddToCart,
  isAddToCartDisabled
}) => {
  return (
    <Dialog 
      open={open} 
      onClose={onClose} 
      maxWidth="sm" 
      fullWidth
      sx={{ 
        '& .MuiDialog-paper': { 
          borderRadius: 3,
          direction: 'rtl'
        } 
      }}
    >
      <DialogTitle 
        sx={{ 
          display: 'flex', 
          justifyContent: 'space-between', 
          alignItems: 'center', 
          pb: 2,
          textAlign: 'right'
        }}
      >
        <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
          اختر اللون والمقاس
        </Typography>
        <IconButton edge="start" onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      
      <Divider />
      
      <DialogContent sx={{ direction: 'rtl', textAlign: 'right' }}>
        {loading ? (
          <Box display="flex" justifyContent="center" my={4}>
            <CircularProgress />
          </Box>
        ) : (
          <>
            {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
            
            <Typography 
              variant="h6" 
              sx={{ 
                mb: 3, 
                fontWeight: 'bold',
                color: '#333'
              }}
            >
              {product.name_ar}
            </Typography>
            
            <ColorSelector
              productColors={productColors}
              selectedColorIndex={selectedColorIndex}
              onColorChange={onColorChange}
            />
            
            <SizeSelector
              availableSizes={availableSizes}
              selectedSize={selectedSize}
              onSizeChange={onSizeChange}
            />
          </>
        )}
      </DialogContent>
      
      <DialogActions sx={{ justifyContent: 'center', p: 3 }}>
        <Button 
          variant="contained" 
          onClick={onAddToCart}
          disabled={isAddToCartDisabled}
          startIcon={<ShoppingBagIcon />}
          fullWidth
          sx={{
            py: 1.5,
            backgroundColor: '#0f3662',
            borderRadius: 2,
            fontWeight: 'bold',
            flexDirection: 'row-reverse',
            '&:hover': { backgroundColor: '#0a2a4a' },
            '&:disabled': { backgroundColor: '#ccc' }
          }}
        >
          إضافة إلى السلة
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ProductSelectionDialog;
